import { render, staticRenderFns } from "./percentage-field.vue?vue&type=template&id=3fddc9c1"
import script from "./percentage-field.vue?vue&type=script&lang=ts"
export * from "./percentage-field.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports